import React from 'react'
import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRouter from './routers/PrivateRouter';
import UsersList from './pages/users/UsersList';
import PropertiesList from './pages/PropertiesList';
import AddProperty from './pages/AddProperty';
import PropertyView from './pages/PropertyView';
import UpdateProperty from './pages/UpdateProperty';
import FlatmatesList from './pages/FlatmatesList';
import FlatmateProfileView from './pages/FlatmateProfileView';
import BannersList from './pages/banners/BannersList';
import CarsList from './pages/cars/CarsList';
import AddCar from './pages/cars/AddCar';
import UpdateCar from './pages/cars/UpdateCar';
import CarView from './pages/cars/CarView';
import CarRequestsList from './pages/cars/CarRequestsList';
import CarBookingsList from './pages/cars/CarBookingsList';
import DriverVerificationsList from './pages/DriverVerificationsList';
import BlogsList from './pages/BlogsList';
import AddBlog from './pages/AddBlog';
import BlogView from './pages/BlogView';
import HirematesList from './pages/HirematesList';
import HiremateCandidateProfileView from './pages/HiremateCandidateProfileView';
import HiremateCandidateRequestsList from './pages/HiremateCandidateRequestsList';
import HiremateJobsList from './pages/HiremateJobsList';
import HiremateJobDetailView from './pages/HiremateJobDetailView';
import HiremateJobRequestsList from './pages/HiremateJobRequestsList';
import HiremateTasksList from './pages/HiremateTasksList';
import HiremateTaskDetailView from './pages/HiremateTaskDetailView';
import TestimonialsList from './pages/TestimonialsList';
import EnquiriesList from './pages/EnquiriesList';
import HiremateEnquiriesList from './pages/HiremateEnquiriesList';
import Messages from './pages/Messages';
import PropertyRequestsList from './pages/PropertyRequestsList';
import PropertyIndividualRequests from './pages/PropertyIndividualRequests';
import InspectionsList from './pages/InspectionsList';
import ContactusEnquiries from './pages/ContactusEnquiries';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<Login />} />
        <Route path="/" element={<Login />} />
        
        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/properties" element={<PropertiesList />} />
          <Route path="/properties/add" element={<AddProperty />} />
          <Route path="/properties/edit/:id" element={<UpdateProperty />} />
          <Route path="/properties/:id" element={<PropertyView />} />
          <Route path="/property-requests" element={<PropertyRequestsList />} />
          <Route path="/property-requests/:propertyId" element={<PropertyIndividualRequests />} />
          <Route path="/inspections" element={<InspectionsList />} />
          <Route path="/flatmates" element={<FlatmatesList />} />
          <Route path="/flatmates/:id" element={<FlatmateProfileView />} />
          <Route path="/banners" element={<BannersList />} />
          <Route path="/cars" element={<CarsList />} />
          <Route path="/cars/add" element={<AddCar />} />
          <Route path="/cars/edit/:id" element={<UpdateCar />} />
          <Route path="/cars/:id" element={<CarView />} />
          <Route path="/car-requests" element={<CarRequestsList />} />
          <Route path="/car-bookings" element={<CarBookingsList />} />
          <Route path="/driver-verifications" element={<DriverVerificationsList />} />
          <Route path="/blogs" element={<BlogsList />} />
          <Route path="/blogs/add" element={<AddBlog />} />
          <Route path="/blogs/:id" element={<BlogView />} />
          <Route path="/hiremates" element={<HirematesList />} />
          <Route path="/hiremates/:id" element={<HiremateCandidateProfileView />} />
          <Route path="/hiremates/:candidateId/requests" element={<HiremateCandidateRequestsList />} />
          <Route path="/hiremate-jobs" element={<HiremateJobsList />} />
          <Route path="/hiremate-jobs/:id" element={<HiremateJobDetailView />} />
          <Route path="/hiremate-jobs/:jobId/requests" element={<HiremateJobRequestsList />} />
          <Route path="/hiremate-tasks" element={<HiremateTasksList />} />
          <Route path="/hiremate-tasks/:id" element={<HiremateTaskDetailView />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/enquiries/student" element={<EnquiriesList type="student" />} />
          <Route path="/enquiries/owner" element={<EnquiriesList type="owner" />} />
          <Route path="/enquiries/agent" element={<EnquiriesList type="agent" />} />
          <Route path="/enquiries/hiremate" element={<HiremateEnquiriesList />} />
          <Route path="/contact-enquiries" element={<ContactusEnquiries />} />
          <Route path="/testimonials" element={<TestimonialsList />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
